export const DEFAULT_AWARD_ITEMS = [
  {
    id: 'award-2023',
    year: '2023',
    content: '청주미술창작스튜디오17기 입주작가',
    content_en: 'Selected as 17th Cheongju Art Studio Resident Artist'
  },
  {
    id: 'award-2021',
    year: '2021',
    content: '온라인 미디어 지원 사업 선정,충북문화재단',
    content_en: 'Selected for Online Media Support Project, Chungbuk Arts Foundation'
  },
  {
    id: 'award-2020',
    year: '2020',
    content: '아트체인지업 지원 사업 선정,한국문화예술위원회',
    content_en: 'Selected for Art Change Up Support Project, Korea Arts Council'
  }
];
